"use client";

import { useContactUs } from "@repo/lib/hooks/common";
import { COUNTRY_CODE_PHONE_PREFIX } from "@repo/constants/common";
import { CONTACT_FORM_FIELDS, CONTACT_FORM_FIELDS_HOMEPAGE } from "@repo/constants/contact-form-fields";
import { Button, ErrorMessage, Input, LoadingDots, TextArea } from "@repo/ui";
import { useTranslations } from "next-intl";
const ContactForm = ({
  isHomepage
}) => {
  const t = useTranslations("Common");
  const {
    handleSubmit,
    handleValidation,
    formValues,
    formErrors,
    isPending
  } = useContactUs({
    isHomepage
  });
  const formFields = isHomepage ? CONTACT_FORM_FIELDS_HOMEPAGE : CONTACT_FORM_FIELDS;
  return <form onSubmit={handleSubmit} className="py-4" data-sentry-component="ContactForm" data-sentry-source-file="ContactForm.jsx">
      <div className="grid grid-cols-1 gap-x-4">
        {formFields?.map(field => <div key={field.id} className={`mb-5 ${field.type === "textarea" ? "col-span-1" : ""}`}>
            {field.type === "input" && <>
                <Input type="text" name={field.name} placeholder={t(field.placeholder)} value={formValues?.[field.name]} onChange={handleValidation} readOnly={field.readOnly} disabled={field.disabled} label={t(field.label)} />
                <ErrorMessage message={formErrors?.[field.name]} />
              </>}
            {field.type === "tel" && <div>
                <label className="mb-2 block text-sm font-medium text-[#5E5E5E]">
                  {t(field.label)}
                </label>
                <div className="relative">
                  {<span className="text-supportiveBlack absolute mt-0.5 inline-flex h-8 items-center bg-gray-100 px-2 text-base font-medium md:h-10 ltr:ml-0.5 rtl:mr-0.5" dir="ltr">
                      {COUNTRY_CODE_PHONE_PREFIX}
                    </span>}
                  <Input type={field.type} name="phoneNumber" placeholder={t(field.placeholder)} value={`${formValues?.phoneNumber}`} onChange={handleValidation} className="ltr:pl-16 rtl:pr-14 rtl:text-right" />
                </div>
                <ErrorMessage message={formErrors?.[field.name]} />
              </div>}
            {field.type === "textarea" && <>
                <TextArea name={field.name} rows={4} cols={40} placeholder={t(field.placeholder)} value={formValues?.[field.name]} onChange={handleValidation} label={t(field.label)} />
                <ErrorMessage message={formErrors?.[field.name]} />
              </>}
          </div>)}
      </div>

      <Button size="md" type="submit" variant="primary" disabled={isPending} className="w-full font-semibold" data-sentry-element="Button" data-sentry-source-file="ContactForm.jsx">
        {isPending ? <LoadingDots className="bg-white" /> : `${t("Submit")}`}
      </Button>
    </form>;
};
export default ContactForm;